import script from "./AdsCabinetCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsCabinetCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./AdsCabinetCreateForm.vue?vue&type=style&index=0&id=8a57f5d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a57f5d6"]])

export default __exports__